import { render, staticRenderFns } from "./IpotekAkitTablosuAlacakForm.vue?vue&type=template&id=2a24bc78"
import script from "./IpotekAkitTablosuAlacakForm.vue?vue&type=script&lang=ts"
export * from "./IpotekAkitTablosuAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports